var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Chips } from '../Chips';
import { Button, Icon, Modal } from '@gerdau/hefesto';
import './UploadFile.styles.scss';
var UploadFile = function (_a) {
    var acceptedFiles = _a.acceptedFiles, _b = _a.buttonLabel, buttonLabel = _b === void 0 ? 'Enviar arquivos' : _b, _c = _a.hideChips, hideChips = _c === void 0 ? false : _c, maxSizeMB = _a.maxSizeMB, onChangeFiles = _a.onChangeFiles, disabled = _a.disabled;
    var _d = useState([]), files = _d[0], setFiles = _d[1];
    var _e = useState([]), chipFiles = _e[0], setChipFiles = _e[1];
    var _f = useState(false), showModal = _f[0], setShowModal = _f[1];
    var onDrop = useCallback(function (filesUploaded) {
        if (filesUploaded[0]) {
            var newFiles = __spreadArray(__spreadArray([], files, true), filesUploaded, true);
            if (hideChips) {
                !!onChangeFiles && onChangeFiles(filesUploaded);
            }
            else {
                setFiles(newFiles);
                convertFilesToChipFormat(newFiles);
                !!onChangeFiles && onChangeFiles(newFiles);
            }
        }
    }, [files]);
    var _g = useDropzone({
        onDrop: onDrop,
        accept: acceptedFiles,
        maxSize: maxSizeMB * 1000000,
        disabled: disabled,
        useFsAccessApi: false,
    }), getRootProps = _g.getRootProps, getInputProps = _g.getInputProps, isDragActive = _g.isDragActive, fileRejections = _g.fileRejections;
    var convertFilesToChipFormat = function (filesUploaded) {
        var newChips = filesUploaded.map(function (file, idx) { return ({
            id: "".concat(file.name, "-").concat(idx),
            label: truncateFilename(file.name),
            tooltipMessage: file.name,
        }); });
        setChipFiles(newChips);
    };
    var truncateFilename = function (fileName) {
        if (fileName.length <= 19)
            return fileName;
        var start = fileName.substring(0, 19);
        var end = fileName.substring(fileName.length - 8, fileName.length);
        return "".concat(start, "...").concat(end);
    };
    var removeFilesFromChips = function (chips) {
        var filesTemp = __spreadArray([], files, true);
        var chipsRemoved = [];
        var chipsLabels = chips.map(function (chip) { return chip.label; });
        var newFiles = filesTemp.filter(function (fileTemp) {
            if (chipsLabels.includes(fileTemp.name) &&
                !chipsRemoved.includes(fileTemp.name)) {
                chipsRemoved.push(fileTemp.name);
                return fileTemp;
            }
        });
        setFiles(newFiles);
        !!onChangeFiles && onChangeFiles(newFiles);
    };
    var getExtensions = function () {
        var extensions = [];
        Object.entries(acceptedFiles).forEach(function (accept) {
            extensions = __spreadArray(__spreadArray([], extensions, true), accept[1], true);
        });
        return (_jsx(_Fragment, { children: extensions.map(function (ext, idx) { return (_jsxs("strong", { children: [ext, ", "] }, idx)); }) }));
    };
    useEffect(function () {
        if (fileRejections.length > 0) {
            setShowModal(true);
        }
        else {
            setShowModal(false);
        }
    }, [fileRejections]);
    var getUploadFileClassName = function () {
        var classList = ['hefesto-upload-file'];
        if (disabled) {
            classList.push('hefesto-upload-file--disabled');
        }
        return classList.join(' ');
    };
    var uploadFileClassName = getUploadFileClassName();
    return (_jsxs("div", __assign({ className: uploadFileClassName }, { children: [_jsxs("div", __assign({ className: "hefesto-upload-file__dropzone ".concat(isDragActive ? 'hefesto-upload-file__dropzone--dragging' : '') }, getRootProps(), { children: [_jsx("input", __assign({}, getInputProps(), { "aria-label": "Upload file" })), _jsx("div", __assign({ className: "hefesto-upload-file__button-wrapper", "aria-hidden": isDragActive }, { children: _jsx(Button, __assign({ icon: _jsx(Icon, { option: "Upload", variant: "light" }), name: "button-upload-files", fullWidth: true, disabled: disabled }, { children: buttonLabel })) })), _jsxs("p", __assign({ className: "text-extensions", "aria-hidden": isDragActive }, { children: ["Ou arraste os arquivos para essa \u00E1rea para enviar.", _jsx("br", {}), " S\u00E3o aceitos arquivos do tipo ", getExtensions(), " com no m\u00E1ximo", ' ', _jsxs("strong", { children: [maxSizeMB, "MB"] }), "."] })), _jsx("p", __assign({ className: "text-drop", "aria-hidden": !isDragActive }, { children: "Solte aqui os arquivos para enviar" }))] })), !hideChips && (_jsx(Chips, { type: "input", chips: chipFiles, updateChips: removeFilesFromChips })), showModal && (_jsx(Modal, __assign({ modalSize: "sm", onClose: function () { return setShowModal(!showModal); }, buttons: {
                    right: {
                        name: 'close-button',
                        children: 'Fechar',
                        onClick: function () { return setShowModal(!showModal); },
                    },
                }, title: "Arquivo(s) inv\u00E1lido(s)" }, { children: _jsxs("div", { children: [_jsx("span", { children: "Alguns arquivos n\u00E3o puderam ser enviados." }), _jsx("br", {}), _jsx("br", {}), _jsxs("span", { children: ["Os formatos aceitos s\u00E3o ", getExtensions(), " com no m\u00E1ximo", ' ', _jsxs("strong", { children: [maxSizeMB, "MB"] }), "."] })] }) })))] })));
};
export default UploadFile;
